export const ru = {
    'minutes': 'минут',
};
